import type { Catalog, CartItemBase } from 'core';

export enum PRODUCT_COMPACT_CONST {
  TEST_ID = 'product-compact',
}

export type ProductCompactProps = Catalog['data'][number] & {
  isBuyIntention: boolean;
  onAddProduct: (code: string) => void;
  onQuantityChange: (queryOptions: CartItemBase) => void;
};
